/**
 * The carousel slide theme
 */
export var CarouselSlideTheme;
(function (CarouselSlideTheme) {
    CarouselSlideTheme["light"] = "light";
    CarouselSlideTheme["dark"] = "dark";
})(CarouselSlideTheme || (CarouselSlideTheme = {}));
